import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { GlobalService } from '../../services/global.service';
import { catchError, map, Observable, of } from 'rxjs';
import { IUser } from '../../interfaces/global.interface';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  providers: [GlobalService],
})
export class SidebarComponent implements OnInit {
  activeTab: 'technical' | 'promotional' = 'technical';
  activeTechnicalRoute: string = '/dashboard';
  activePromotionalRoute: string = '/event-and-announcements';
  isIncentive: boolean = false;

  technicalRoutes = [
    'dashboard',
    'update-profile',
    'survey-response',
    'submit-rd-needs',
    'apply-for-rating',
    'feedbacks',
  ];
  promotionalRoutes = [
    'event-and-announcements',
    'appointment-request-form',
    'need-support',
    'circulars',
    'government-policies',
  ];

  @Output() menuToggled = new EventEmitter<boolean>();
  isAdminUser!: boolean;
  iseligibleForIncentive!: boolean;
  user!: IUser | null;
  checkCategory: string = '';

  constructor(
    private globalService: GlobalService,
    private router: Router,
  ) {
    this.isAdmin().subscribe((isAdmin) => {
      this.isAdminUser = isAdmin;
    });
  }

  ngOnInit(): void {
    const incentiveScheme = localStorage.getItem('isIncentive');
    this.isIncentive = incentiveScheme === 'true';
    const currentUrl = this.router.url.replace('/', '');
    if (this.technicalRoutes.includes(currentUrl)) {
      this.activeTab = 'technical';
    } else if (this.promotionalRoutes.includes(currentUrl)) {
      this.activeTab = 'promotional';
    }
    this.eligibleForIncentive();
  }

  switchTab(tab: 'technical' | 'promotional') {
    this.activeTab = tab;
    if (tab === 'technical') {
      this.router.navigate(['/dashboard']);
    } else {
      this.router.navigate(['/event-and-announcements']);
    }
  }

  setActiveRoute(route: string) {
    if (this.activeTab === 'technical') {
      this.activeTechnicalRoute = route;
    } else {
      this.activePromotionalRoute = route;
    }
    this.router.navigate([route]);
  }

  isAdmin(): Observable<boolean> {
    const token = sessionStorage.getItem('accessToken') as string;
    return this.globalService.whoAmI(token).pipe(
      map((res: any) => {
        this.checkCategory =
          res.body.accountsMainCategories[0].mainCategory['name'];
        const isBody = res.body;
        if (isBody?.isAdmin === false && isBody.role === 'admin') {
          return true;
        } else {
          return false;
        }
      }),
      catchError((err) => {
        console.error('Error fetching user info', err);
        return of(false);
      }),
    );
  }
  eligibleForIncentive() {
    this.globalService.user$.subscribe((user) => {
      this.user = user;

      if (!user || !Array.isArray(user.accountsMainCategories)) {
        this.iseligibleForIncentive = false;
        return;
      }

      // Check inside accountsMainCategories
      this.iseligibleForIncentive = user.accountsMainCategories.some(
        (mainCat) =>
          mainCat?.accountsCategory?.some(
            (cat) =>
              cat?.category?.name === 'Recyclers' &&
              cat.category.isCritical === true,
          ),
      );
    });
  }
  isActive(path: string): boolean {
    return this.router.url === path;
  }
}
